import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {RootState} from '@/store'
import {CustomerServiceState} from "@/store/modules/customerService/index";
import {RequestPayload, ServiceApi} from "@payroll/optimus-common";
import {ActionTree} from 'vuex'


export const actions: ActionTree<CustomerServiceState, RootState> = {


  getMemberDetails: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getMemberDetails')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  getEmployerDetails: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getEmployerDetails')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  getEmployerDetailsByCRMId: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getEmployerDetailsByCRMId')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  getEmployerDetailsByHpNumAndName: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getEmployerDetailsByHpNumAndName')
      .setRequestBody(requestBody)
      .post(requestorCallback);
  },

  getSourceOfArrival: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getSourceOfArrival')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  managingCompanyCRMName: ({commit, dispatch, state, rootGetters}: any, {requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('managingCompanyCRMName')
      .get(requestorCallback)
  },

  getSubjectOfArrival: ({commit, dispatch, state, rootGetters}: any, {requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getSubjectOfArrival')
      .get(requestorCallback)
  },

  getSubjectOfArrivalByCrmFilterType: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getSubjectOfArrivalByCrmFilterType')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  getCRMDepartments: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getCRMDepartments')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  getAllCRMDepartments: ({commit, dispatch, state, rootGetters}: any, {requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('crmConfigurationManagement/getAllCRMDepartments')
      .get(requestorCallback)
  },

  getServicePriorities: ({commit, dispatch, state, rootGetters}: any, {requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('servicePriorities')
      .get(requestorCallback)
  },

  createNewCRMContact: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('createNewCRMContact')
      .setRequestBody(requestBody)
      .post(requestorCallback);
  },

  updateCRMContact: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('updateCRMContact')
      .setRequestBody(requestBody)
      .put(requestorCallback);
  },

  updateRoutingUser: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('updateRoutingUser')
      .setRequestBody(requestBody)
      .put(requestorCallback);
  },

  uploadCRMAttachedFiles: ({state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('uploadCRMAttachedFiles')
      .setRequestBody(requestBody)
      .post(requestorCallback);
  },

  sendNotification: ({state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('sendNotification')
      .setRequestBody(requestBody)
      .post(requestorCallback);
  },

  fetchCRMContacts: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('CRMContacts')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  exportCRMContacts: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('exportCRMContacts')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  getAllStatusesTypes: ({commit, dispatch, state, rootGetters}: any, {requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('statusesTypes')
      .get(requestorCallback)
  },

  getAllStatusesTypesByCrmFilterType: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('statusesTypesByCrmFilterType')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  getAllCRMUsers: ({commit, dispatch, state, rootGetters}: any, {requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getAllCRMUsers')
      .get(requestorCallback)
  },

  getUsersBySubjectOfArrivalId: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getUsersBySubjectOfArrivalId')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  getUsersByDepartmentId: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getUsersByDepartmentId')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  getAttachmentCrm: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('attachmentCrm')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  getAttachmentMemberCrm: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('attachmentMemberCrm')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  deleteAttachmentCrm: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('deleteAttachmentCrm')
      .setPathVariable(pathVariable)
      .put(requestorCallback)
  },

  downloadAttachmentCrm: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('downloadAttachmentCrm')
      .setPathVariable(pathVariable)
      .post(requestorCallback)
  },

  downloadDocumentAsZipFile: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, requestBody}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('downloadDocumentAsZipFile')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },



  getCustomerServiceCRMGroup: ({commit, dispatch, state, rootGetters}: any, {requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getCustomerServiceCRMGroup')
      .get(requestorCallback)
  },

  getDistributionOfCRMInquiriesPaiChartData: ({commit, dispatch, state, rootGetters}: any, {requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getDistributionOfCRMInquiriesPaiChartData')
      .get(requestorCallback)
  },

  getCRMInquiriesByDateAndDepartmentBarData: ({commit, dispatch, state, rootGetters}: any, {requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getCRMInquiriesByDateAndDepartmentBarData')
      .get(requestorCallback)
  },

  getCRMInquiriesByDateAndArrivalSubjectBarData: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, requestBody}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getCRMInquiriesByDateAndArrivalSubjectBarData')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  getSubAccounts: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/subAccounts')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  getMemberContactCallHistory: ({commit, dispatch, state, rootGetters}: any, {
    requestBody,
    requestorCallback,
    pathVariable
  }: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/getMemberContactCallHistory')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  getRestrictions: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/restrictions')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  getMemberActivityLoan: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/activityLoan')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  getAllProcess: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/allProcess')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  getLoanProcess: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/loanProcess')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  getCrmHistory: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('crmHistory')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },


  fetchMemberTransactions: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/transactions')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  getWithdrawalAndTransfer: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('withdrawalAndTransfer')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  getCRMContact: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('CRMContacts')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  getMemberSecurities: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/memberSecurities')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  getMemberSecuritiesReport: ({commit, dispatch, state, rootGetters}: any, {
    requestBody,
    requestorCallback
  }: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/memberSecuritiesReport')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  accountsDetailsReport: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/accountsDetailsReport')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  getMemberBeneficiaries: ({commit, dispatch, state, rootGetters}: any, {
    requestBody,
    requestorCallback
  }: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/getMemberBeneficiaries')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  getSecuritiesCaseNumbers: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/memberCaseNumbers')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  getMemberDocumentumConfig: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/memberDocumentumConfig')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  downloadMemberReport: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/downloadMemberReport')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  getMemberReports: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, requestBody}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/getMemberReports')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  searchEmployee: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, requestBody}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/searchEmployees')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  getEmployeeDetails: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/getEmployeeDetails')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  exportEmployees: ({commit, dispatch, state, rootGetters}: any, {pathVariable, requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/exportEmployees')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  getEmployeeCardTabs: ({commit, dispatch, state, rootGetters}: any, {requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/getEmployeeCardTabs')
      .get(requestorCallback)
  },

  addUserToDepartment: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, requestBody}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('crmConfigurationManagement/addUserToDepartment')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  createOrUpdateArrivalSubject: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, requestBody}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('crmConfigurationManagement/createOrUpdateArrivalSubject')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  createOrUpdateDepartmentCRM: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, requestBody}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('crmConfigurationManagement/createOrUpdateDepartmentCRM')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  removeUserFromDepartment: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, requestBody}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('crmConfigurationManagement/removeUserFromDepartment')
      .setRequestBody(requestBody)
      .put(requestorCallback)
  },

  getAllSubjectsByDepartment: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('crmConfigurationManagement/getAllSubjectsByDepartment')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  getDepartmentDetails: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('crmConfigurationManagement/getDepartmentDetails')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  getAllMangingCompanyUsers: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('crmConfigurationManagement/getAllMangingCompanyUsers')
      .get(requestorCallback)
  },

  getAllCRMStatuses: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('crmConfigurationManagement/getAllCRMStatuses')
      .get(requestorCallback)
  },

  getAllCRMArrivalSources: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('crmConfigurationManagement/getAllCRMArrivalSources')
      .get(requestorCallback)
  },

  createOrUpdateStatusCRM: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, requestBody}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('crmConfigurationManagement/createOrUpdateStatusCRM')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  createOrUpdateArrivalSourceCRM: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, requestBody}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('crmConfigurationManagement/createOrUpdateArrivalSourceCRM')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  getConfigCRMDetails: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('crmConfigurationManagement/getConfigCRMDetails')
      .get(requestorCallback)
  },

  updateConfigCRM: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, requestBody}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('crmConfigurationManagement/updateConfigCRM')
      .setRequestBody(requestBody)
      .put(requestorCallback)
  },

  updatePersonalDetails: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, requestBody}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/updatePersonalDetails')
      .setRequestBody(requestBody)
      .put(requestorCallback)
  },

  exportAccountDetails: ({commit, dispatch, state, rootGetters}: any, {pathVariable, requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/exportAccountDetails')
      .setPathVariable(pathVariable)
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },


  getAccountDetails: ({commit, dispatch, state, rootGetters}: any, {pathVariable, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/getAccountDetails')
      .setPathVariable(pathVariable)
      .post(requestorCallback)
  },

  getEmployeeReports: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, requestBody}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters['authorization/accessToken'])
      .setRequestName('findMembersOrEmployersFor/getEmployeeReports')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  generateEmployeeReport: ({commit, dispatch, state, rootGetters}: any, {pathVariable, requestorCallback, requestBody}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters['authorization/accessToken'])
      .setRequestName('findMembersOrEmployersFor/generateEmployeeReport')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  generateEmployee161Report: ({commit, dispatch, state, rootGetters}: any, {
    pathVariable,
    requestorCallback,
    requestBody
  }: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters['authorization/accessToken'])
      .setRequestName('findMembersOrEmployersFor/generateEmployee161Report')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },


  getArrearsAlerts: ({commit, dispatch, state, rootGetters}: any, {pathVariable, requestorCallback, requestBody}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/getArrearsAlerts')
      .setPathVariable(pathVariable)
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  getEmployerDeposits: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/getEmployerDeposits')
      .setRequestBody(requestBody)
      .post(requestorCallback);
  },

  getEmployerDepositSettings: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/getEmployerDepositSettings')
      .setRequestBody(requestBody)
      .get(requestorCallback);
  },

  getTabsConfiguration: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/tabsConfiguration')
      .get(requestorCallback);
  },

  showEmployee161Report: ({commit, dispatch, state, rootGetters}: any, {
    pathVariable,
    requestorCallback
  }: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/showEmployee161Report')
      .setPathVariable(pathVariable)
      .get(requestorCallback);
  },

  exportEmployerDeposits: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('findMembersOrEmployersFor/exportEmployerDeposits')
      .setRequestBody(requestBody)
      .post(requestorCallback);
  },
}